module.exports = __webpack_public_path__ + "static/img/teacher_pd.47e1af97.jpg";